import { useState } from "react";

import { IOvertimeRequestQuery } from "../../models/Hrm";
import { useGetOvertimeRequests } from "../../query/HrmQuery";

import HrmOvertimeTable from "../../components/hrm/HrmOvertimeTable";

export const HrmOvertimeRequests = () => {
  const [filter, setFilter] = useState<IOvertimeRequestQuery>({
    page: 1,
    limit: 10,
  });
  const { data, isLoading } = useGetOvertimeRequests(filter);
  return (
    <HrmOvertimeTable
      data={data!}
      isLoading={isLoading}
      isHasAvatars={true}
      filter={filter}
      setFilter={setFilter}
    />
  );
};
